// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SafeIcon from "../../view/assets/SafeIcon.bs.js";
import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as WarningIcon from "../../view/assets/WarningIcon.bs.js";
import * as PartnerScoreConfig from "../store/PartnerScoreConfig.bs.js";
import * as PartnerScoreHelper from "./PartnerScoreHelper.bs.js";
import * as PartnerScoreAssetConfig from "../../view/assets/PartnerScoreAssetConfig.bs.js";

function getMilestoneIcon(current_score, max_score, index, track_thresholds, isSuspended, action_threshold) {
  var total_thresholds = track_thresholds.length;
  var float_track_threshold = PartnerScoreHelper.thresholdValueToFloat(Caml_array.get(track_thresholds, index));
  var float_action_threshold = PartnerScoreHelper.thresholdValueToFloat(action_threshold);
  var match = current_score >= max_score;
  var match$1 = index === 0;
  var match$2 = index === (total_thresholds - 1 | 0);
  var match$3 = float_track_threshold === float_action_threshold;
  var match$4 = float_track_threshold < float_action_threshold;
  var match$5 = float_track_threshold > float_action_threshold;
  var exit = 0;
  if (match) {
    var exit$1 = 0;
    if (match$1) {
      if (!match$2) {
        return React.createElement(SafeIcon.make, {
                    circle_fill_color: "#CED1D5",
                    path_fill_color: "#9499A3"
                  });
      }
      exit$1 = 3;
    } else {
      if (match$2) {
        return React.createElement("img", {
                    src: PartnerScoreAssetConfig.danger_milestone_icon
                  });
      }
      exit$1 = 3;
    }
    if (exit$1 === 3) {
      return React.createElement(WarningIcon.make, {
                  fill_color: "#CED1D5",
                  inner_stroke_color: "#9499A3",
                  outer_stroke_color: "#CED1D5"
                });
    }
    
  } else {
    var exit$2 = 0;
    if (match$1) {
      if (!match$2) {
        return React.createElement(SafeIcon.make, {
                    circle_fill_color: "#32926D",
                    path_fill_color: "#FCFCFC"
                  });
      }
      exit$2 = 3;
    } else {
      if (match$2) {
        return React.createElement("img", {
                    src: PartnerScoreAssetConfig.danger_milestone_icon
                  });
      }
      exit$2 = 3;
    }
    if (exit$2 === 3) {
      if (match$3) {
        if (match$4 || match$5) {
          exit = 1;
        } else {
          if (isSuspended) {
            return React.createElement(WarningIcon.make, {
                        fill_color: Caml_array.get(PartnerScoreConfig.fill_color, index - 1 | 0),
                        inner_stroke_color: Caml_array.get(PartnerScoreConfig.inner_stroke_color, index - 1 | 0),
                        outer_stroke_color: Caml_array.get(PartnerScoreConfig.outer_stroke_color, index - 1 | 0)
                      });
          }
          exit = 2;
        }
      } else {
        exit = match$4 && !match$5 ? 2 : 1;
      }
    }
    
  }
  switch (exit) {
    case 1 :
        return React.createElement(WarningIcon.make, {
                    fill_color: Caml_array.get(PartnerScoreConfig.fill_color, index - 1 | 0),
                    inner_stroke_color: Caml_array.get(PartnerScoreConfig.inner_stroke_color, index - 1 | 0),
                    outer_stroke_color: Caml_array.get(PartnerScoreConfig.outer_stroke_color, index - 1 | 0)
                  });
    case 2 :
        return React.createElement(WarningIcon.make, {
                    fill_color: "#CED1D5",
                    inner_stroke_color: "#9499A3",
                    outer_stroke_color: "#CED1D5"
                  });
    
  }
}

function getThresholdIcon(index, thresholds_length) {
  if (PartnerScoreHelper.isLastIndex(index, thresholds_length)) {
    return React.createElement("img", {
                src: PartnerScoreAssetConfig.danger_milestone_icon
              });
  } else {
    return React.createElement(WarningIcon.make, {
                fill_color: Caml_array.get(PartnerScoreConfig.fill_color, index),
                inner_stroke_color: Caml_array.get(PartnerScoreConfig.inner_stroke_color, index),
                outer_stroke_color: Caml_array.get(PartnerScoreConfig.outer_stroke_color, index)
              });
  }
}

export {
  getMilestoneIcon ,
  getThresholdIcon ,
  
}
/* react Not a pure module */
